// eslint-disable-next-line import/prefer-default-export
export const INCOTERMS_LIST = [
    'EXW',
    'FCA',
    'FAS',
    'FOB',
    'CFR',
    'CIF',
    'CIP',
    'CPT',
    'DPU',
    'DAP',
    'DDP',
];



// WEBPACK FOOTER //
// ./app/constants/incoterms.js